import { ABOUT_YOUR_LOAN_URL } from "App.const";
import { AboutYouForm } from "components/AboutYou/AboutYouForm";
import { AboutYou } from "domain/aboutYou";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { Store } from "state/store";
import { ABOUT_YOUR_SCREEN_TITLE } from "./Title.const";

type AboutYouScreenProps = {
  store: Store;
};

const AboutYouScreen = ({ store }: AboutYouScreenProps) => {
  document.title = ABOUT_YOUR_SCREEN_TITLE;
  const navigate = useNavigate();

  const handleSubmit = (aboutYou: AboutYou) => {
    store.aboutYouStore.storeAboutYou(aboutYou);
    navigate(ABOUT_YOUR_LOAN_URL, { replace: true });
  };

  return (
    <>
      <AboutYouForm
        aboutYou={store.aboutYouStore.data}
        onSubmit={handleSubmit}
      />
    </>
  );
};

const AboutYouScreenObserver = observer(AboutYouScreen);
export { AboutYouScreenObserver as AboutYouScreen };
